// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_025a50318d--tooltip--6nQNC","arrow":"_025a50318d--arrow--Svkjk","close":"_025a50318d--close--1hVTu"};